/* eslint-disable react/prop-types */
import * as React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import styles from './Dialog.module.css';
import clsx from 'clsx';
import { DialogIberiaProps, IbReactModal } from './DialogIberia';

const Dialog = DialogPrimitive.Root;

const DialogTrigger = DialogPrimitive.Trigger;

const DialogPortal = DialogPrimitive.Portal;

const DialogOverlay = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Overlay>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
	<DialogPrimitive.Overlay ref={ref} className={clsx(styles.overlay, className)} {...props} />
));
DialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

const DialogContent = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Content>,
	React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
	<DialogPortal>
		<DialogOverlay />
		<DialogPrimitive.Content ref={ref} className={clsx(styles.content, className)} {...props}>
			{children}
		</DialogPrimitive.Content>
	</DialogPortal>
));
DialogContent.displayName = DialogPrimitive.Content.displayName;

const DialogIberiaContent = React.forwardRef<
	React.ElementRef<typeof DialogPrimitive.Content>,
	DialogIberiaProps & { className?: string; defaultOutsider?: boolean; isHidden?: boolean }
>(({ className, defaultOutsider = true, children, isHidden = false, ...props }, ref): React.ReactNode => {
	// Delete aria described by if the argument is not passed (https://www.radix-ui.com/primitives/docs/components/dialog#description)
	const describedby = props.subtitle ? {} : { 'aria-describedby': undefined };
	const avoidDefaultDomBehavior = (e: Event) => {
		if (!defaultOutsider) e.preventDefault();
	};
	return (
		<DialogPortal>
			<DialogOverlay />
			<DialogPrimitive.Content
				ref={ref}
				className={clsx(styles.content, className)}
				{...describedby}
				onPointerDownOutside={avoidDefaultDomBehavior}
				onInteractOutside={avoidDefaultDomBehavior}
				aria-hidden={isHidden}
			>
				<IbReactModal {...props}>{children}</IbReactModal>
			</DialogPrimitive.Content>
		</DialogPortal>
	);
});
DialogIberiaContent.displayName = DialogPrimitive.Content.displayName;

export { Dialog, DialogTrigger, DialogContent, DialogIberiaContent };
